import { RefObject, useEffect, useState } from 'react';
import { getFromEnterpriseBackend } from '../../../../utils/api';
import useIsVisible from '../../../../utils/useIsVisible';
import { Sources } from '../../ResponsiveImage';

type Impacter = {
  actionShotWideSources: Sources;
  headShotSources: Sources;
};

/**
 * Each Sources field generate a large size of data (200B url string times 4, times 3).
 * This hook is a workaround to load that data only when needed
 */
const useLazyLoadedSources = ({ id, ref }: { id: number; ref: RefObject<Element> }) => {
  const [intersected, setIntersected] = useState(false);
  const [impacter, setImpacter] = useState<Impacter>();
  useIsVisible({
    ref,
    onIntersecting: ({ isIntersecting }) => {
      isIntersecting && setIntersected(true);
    },
  });
  useEffect(() => {
    if (!intersected) {
      return;
    }
    async function loadImpacter() {
      const impacter = (
        await getFromEnterpriseBackend<{
          result: {
            actionShotWideSources: Sources;
            headShotSources: Sources;
          };
        }>(`impacters/${id}`, {
          fields: ['actionShotWide', 'headShot'],
        })
      ).result;
      setImpacter(impacter);
    }
    loadImpacter();
  }, [id, intersected]);

  return impacter;
};

export default useLazyLoadedSources;
